import $ from "jquery";
import "select2";

/**
 * Automatically initializes `Select2` instances for elements with the `data-sel2` attribute.
 */
export function initializeSelect2(): void {
    $(() => {
        // Set default values for Select2
        $.fn.select2.defaults.set("allowClear", false);

        $("select[data-sel2]").each(function () {
            const obj = $(this);
            const id = obj.attr("id");
            if (id) {
                InCoreSelect2(id);
            }
        });
    });
}

/**
 * Semi-automatic activation of `Select2`.
 * @param {string} id - The ID of the `select` element.
 * @returns {JQuery} - The initialized `Select2` instance.
 */
export function InCoreSelect2(id: string): JQuery {
    const obj = $(`#${id}`);
    const nosearch = obj.attr("data-nosearch") === "true";
    const allowclear = obj.attr("data-allowclear") === "true";
    const placeholder = obj.attr("data-placeholder") ?? undefined;
    const searchInputPlaceholder = obj.attr('data-searchInputPlaceholder') ?? undefined;
    const pagination = obj.attr("data-pagination") ?? undefined;
    const ajaxurl = obj.attr("data-ajax") ?? undefined;
    const where = obj.attr("data-where") ?? undefined;
    const orderby = obj.attr("data-orderby") ?? undefined;

    return configureSelect2(
        id,
        ajaxurl,
        nosearch,
        allowclear,
        placeholder,
        searchInputPlaceholder,
        where,
        orderby,
        pagination
    );
}

/**
 * Manual activation of `Select2` with advanced configuration.
 * @param {string} id - The ID of the `select` element.
 * @param {string | undefined} ajaxurl - The URL for AJAX requests.
 * @param {boolean} nosearch - Whether to disable the search feature.
 * @param {boolean} allowclear - Whether to allow clearing the selection.
 * @param {string | undefined} placeholder - The placeholder text.
 * @param {string | undefined} searchInputPlaceholder - The placeholder text of the search box inside.
 * @param {string | undefined} viewWhere - Filter to apply to the `Select2`.
 * @param {string | undefined} viewOrderBy - Order by clause for the `Select2`.
 * @param {string | undefined} itemPerPage - Number of items per page for pagination.
 * @param {string} width - The width of the `Select2` dropdown (default: "100%").
 * @returns {JQuery} - The initialized `Select2` instance.
 */
export function configureSelect2(
    id: string,
    ajaxurl: string | undefined,
    nosearch: boolean = false,
    allowclear: boolean = false,
    placeholder: string | undefined = undefined,
    searchInputPlaceholder: string | undefined = undefined,
    viewWhere: string | undefined = undefined,
    viewOrderBy: string | undefined = undefined,
    itemPerPage: string | undefined = undefined,
    width: string = "100%"
): JQuery {
    const param: any = {
        language: "it",
        width: width,
    };

    // Set dropdown parent for modals: senza di questo select2 appende il pannello al
    // body e dentro una modale esce disallineato e piu' stretto del campo.
    const modale = $(`#${id}`).closest(".InCoreModalBody, .modal");
    if (modale.length > 0) {
        param.dropdownParent = modale;
    }

    // Allow clearing the selection
    if (allowclear) {
        param.allowClear = true;
        param.placeholder = "";
    }

    // Disable search
    if (nosearch) {
        param.minimumResultsForSearch = -1;
    }

    // Set placeholder
    if (placeholder) {
        param.placeholder = placeholder;
    }

    // Set Input Placeholder
    if (searchInputPlaceholder) {
        param.searchInputPlaceholder = searchInputPlaceholder;
    }

    // Enable pagination
    if (itemPerPage) {
        param.pagination = { more: true };
    }

    // Configure AJAX
    if (ajaxurl) {
        param.ajax = {
            url: ajaxurl,
            dataType: "json",
            delay: 250,
            data: (params: any) => ({
                _type: params._type,
                term: params.term || "",
                page: params.page || 1,
                itemPerPage: itemPerPage,
                where: viewWhere,
                orderby: viewOrderBy,
            }),
            processResults: (data: any) => ({
                pagination: { more: data.pagination.more },
                results: data.results.map((item: any) => ({
                    text: item.text,
                    id: item.id,
                })),
            }),
        };
    }

    // Initialize Select2
    const selectElement = $(`select#${id}`);
    //selectElement.on("select2:open", () => {
    //    setTimeout(() => {
    //        $("input.select2-search__field").attr("placeholder", param.searchInputPlaceholder);
    //    }, 0);
    //});

    return selectElement.select2(param) as unknown as JQuery<HTMLElement>;
}

export function InCoreSelect2Filter(id: string, filter: string): JQuery {
    const obj = $(`#${id}`);
    obj.data("where", filter);
    obj.val("").trigger("change");

    return InCoreSelect2(id);
}